/** Solid menu backgrounds for react-select (avoids transparent dropdowns over page content). */
export const solidMenuReactSelectStyles = {
  control: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: "#ffffff",
  }),
  menu: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: "#ffffff",
    zIndex: 50,
  }),
  menuPortal: (base: Record<string, unknown>) => ({
    ...base,
    zIndex: 9999,
  }),
  menuList: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: "#ffffff",
  }),
  option: (
    base: Record<string, unknown>,
    state: { isFocused: boolean; isSelected: boolean }
  ) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "#dbeafe"
      : state.isFocused
        ? "#f3f4f6"
        : "#ffffff",
    color: "#111827",
  }),
};

export const solidMenuReactSelectProps = {
  menuPortalTarget: document.body,
  menuPosition: "fixed" as const,
  styles: solidMenuReactSelectStyles,
};
